import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  CardHeader,
  FormGroup,
  Input,
} from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  editCompanyIDSuccess,
  saveCompany,
  saveCompany_Success,
  updateCompanyID,
  getCompanyGroup,
  updateCompanyIDSuccess
} from "../../../store/Administrator/CompanyRedux/actions";
import { MetaTags } from "react-meta-tags";
import { commonPageField, commonPageFieldSuccess } from "../../../store/actions";
import { Breadcrumb_inputName } from "../../../store/Utilites/Breadcrumb/actions";
import { useHistory } from "react-router-dom";
import {
  comAddPageFieldFunc,
  formValid,
  initialFiledFunc,
  onChangeSelect,
  onChangeText,
  resetFunction,
} from "../../../components/Common/validationFunction";
import { SaveButton } from "../../../components/Common/CommonButton";
import {
  breadcrumbReturnFunc,
  btnIsDissablefunc,
  loginUserID,
  metaTagLabel
} from "../../../components/Common/CommonFunction";
import * as url from "../../../routes/route_url";
import * as pageId from "../../../routes/allPageID"
import * as mode from "../../../routes/PageMode"
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import SERVER_HOST_PATH from "../../../helpers/_serverPath";
const CompanyModule = (props) => {


  const dispatch = useDispatch();
  const history = useHistory()

  const fileds = {
    id: "",
    Name: "",
    Address: "",
    GSTIN: "",
    PhoneNo: "",
    CompanyAbbreviation: "",
    EmailID: "",
    CompanyGroupName: "",
    IsSCM: false,
    CompanyLogo: null,
    BackgroundImage: null
  }

  const [state, setState] = useState(() => initialFiledFunc(fileds))

  const [modalCss, setModalCss] = useState(false);
  const [pageMode, setPageMode] = useState(mode.defaultsave);
  const [userPageAccessState, setUserAccState] = useState('');
  const [editCreatedBy, seteditCreatedBy] = useState("");
  const [logoPreview, setLogoPreview] = useState(null);
  const [bgPreview, setBgPreview] = useState(null);

  const MEDIA_URL = `${SERVER_HOST_PATH}/media/`;




  //Access redux store Data /  'save_ModuleSuccess' action data
  const { postMsg,
    updateMsg,
    CompanyGroup,
    userAccess,
    saveBtnloading,
    pageField } = useSelector((state) => ({
      saveBtnloading: state.Company.saveBtnloading,
      postMsg: state.Company.postMsg,
      updateMsg: state.Company.updateMessage,
      CompanyGroup: state.Company.CompanyGroup,
      userAccess: state.Login.RoleAccessUpdateData,
      pageField: state.CommonPageFieldReducer.pageField
    }));

  useEffect(() => {
    const page_Id = pageId.COMPANY
    dispatch(commonPageFieldSuccess(null));
    dispatch(commonPageField(page_Id))
    dispatch(getCompanyGroup());
  }, [dispatch]);

  const values = { ...state.values }
  const { isError } = state;
  const { fieldLabel } = state;

  const location = { ...history.location }
  const hasShowloction = location.hasOwnProperty(mode.editValue)
  const hasShowModal = props.hasOwnProperty(mode.editValue)

  // userAccess useEffect
  useEffect(() => {
    let userAcc = null;
    let locationPath = location.pathname;

    if (hasShowModal) {
      locationPath = props.masterPath;
    };

    userAcc = userAccess.find((inx) => {
      return (`/${inx.ActualPagePath}` === locationPath)
    })

    if (userAcc) {
      setUserAccState(userAcc);
      breadcrumbReturnFunc({ dispatch, userAcc });
    };
  }, [userAccess])

  useEffect(() => {

    if ((hasShowloction || hasShowModal)) {

      let hasEditVal = null
      if (hasShowloction) {
        setPageMode(location.pageMode)
        hasEditVal = location.editValue
      }
      else if (hasShowModal) {
        hasEditVal = props.editValue
        setPageMode(props.pageMode)
        setModalCss(true)
      }

      if (hasEditVal) {

        const { id, Name, Address, GSTIN, PhoneNo, CompanyAbbreviation, EmailID, CompanyGroup, CompanyGroupName, IsSCM } = hasEditVal
        const { values, fieldLabel, hasValid, required, isError } = { ...state }

        hasValid.Name.valid = true;
        hasValid.Address.valid = true;
        hasValid.GSTIN.valid = true;
        hasValid.PhoneNo.valid = true;
        hasValid.CompanyAbbreviation.valid = true;
        hasValid.EmailID.valid = true;
        hasValid.CompanyGroupName.valid = true;
        hasValid.IsSCM.valid = true;

        values.id = id
        values.Name = Name
        values.Address = Address;
        values.GSTIN = GSTIN;
        values.PhoneNo = PhoneNo;
        values.IsSCM = IsSCM;
        values.CompanyAbbreviation = CompanyAbbreviation;
        values.EmailID = EmailID;
        values.CompanyGroupName = { label: CompanyGroupName, value: CompanyGroup };
        setState({ values, fieldLabel, hasValid, required, isError })
        dispatch(Breadcrumb_inputName(hasEditVal.Name))
        seteditCreatedBy(hasEditVal.CreatedBy)
      }
      dispatch(editCompanyIDSuccess({ Status: false }))
    }

  }, []);

  useEffect(async () => {

    if ((postMsg.Status === true) && (postMsg.StatusCode === 200)) {
      dispatch(saveCompany_Success({ Status: false }))
      setState(() => resetFunction(fileds, state))// Clear form values 
      dispatch(Breadcrumb_inputName(''))

      if (pageMode === "other") {
        customAlert({
          Type: 1,
          Message: postMsg.Message,
        })
      }
      else {
        let isPermission = await customAlert({
          Type: 1,
          Status: true,
          Message: postMsg.Message,
        })
        if (isPermission) {
          history.push({ pathname: url.COMPANY_lIST })
        }
      }
    }
    else if ((postMsg.Status === true)) {
      dispatch(saveCompany_Success({ Status: false }))
      customAlert({
        Type: 4,
        Message: JSON.stringify(postMsg.Message),
      })
    }
  }, [postMsg])

  useEffect(() => {
    if (updateMsg.Status === true && updateMsg.StatusCode === 200) {

      //  form reset
      setState(() => initialFiledFunc(fileds));

      //  image preview reset
      setLogoPreview(null);
      setBgPreview(null);

      //  breadcrumb reset
      dispatch(Breadcrumb_inputName(""));

      //  redirect 
      if (!modalCss) {
        history.push({ pathname: url.COMPANY_lIST });
      }
    }
  }, [updateMsg]);
  ;

  useEffect(() => {
    if (pageField) {
      const fieldArr = pageField.PageFieldMaster
      comAddPageFieldFunc({ state, setState, fieldArr })
    }
  }, [pageField])


  useEffect(() => {


    const editData = hasShowModal
      ? props.editValue
      : location.editValue;

    if (editData) {


      if (editData.CompanyLogo) {

        setLogoPreview(`${MEDIA_URL}${editData.CompanyLogo}`);
      }


      if (editData.BackgroundImage) {

        setBgPreview(`${MEDIA_URL}${editData.BackgroundImage}`);
      }
    }
  }, []);







  const CompanyGroupValues = CompanyGroup.map((Data) => ({
    value: Data.id,
    label: Data.Name
  }));


  const SaveHandler = async (event) => {

    event.preventDefault();
    const btnId = event.target.id;

    try {
      if (formValid(state, setState)) {

        if (
          values.CompanyAbbreviation &&
          (values.CompanyAbbreviation.includes(" ") ||
            !/^[A-Z]+$/.test(values.CompanyAbbreviation))
        ) {
          setState((prev) => ({
            ...prev,
            isError: {
              ...prev.isError,
              CompanyAbbreviation:
                "Only capital letters (A-Z) without spaces allowed",
            },
          }));
      
          return; //  STOP SAVE (API call honar nahi)
        }

        btnIsDissablefunc({ btnId, state: true });

        //  show all errors together
        let hasError = false;
        let errorState = { ...state.isError };

        // Logo validation
        if (!values.CompanyLogo && !logoPreview) {
          errorState.CompanyLogo = "Company Logo is required.";
          hasError = true;
        } else {
          errorState.CompanyLogo = "";
        }

        // Background validation
        if (!values.BackgroundImage && !bgPreview) {
          errorState.BackgroundImage = "Background Image is required.";
          hasError = true;
        } else {
          errorState.BackgroundImage = "";
        }

        // update state once
        setState(i => ({
          ...i,
          isError: errorState
        }));

        // stop save if any error
        if (hasError) return;



        const formData = new FormData();

        // 🔹 Normal fields
        formData.append("Name", values.Name);
        formData.append("Address", values.Address);
        formData.append("GSTIN", values.GSTIN);
        formData.append("PhoneNo", values.PhoneNo);
        formData.append("CompanyAbbreviation", values.CompanyAbbreviation);
        formData.append("EmailID", values.EmailID);
        formData.append("CompanyGroup", values.CompanyGroupName.value);
        formData.append("IsSCM", values.IsSCM);
        formData.append("CreatedBy", loginUserID());
        formData.append("UpdatedBy", loginUserID());

        // 🔹 Images
        // CompanyLogo
        if (values.CompanyLogo) {
          formData.append("CompanyLogo", values.CompanyLogo);
        } else {
          formData.append("CompanyLogo", "");
        }

        // BackgroundImage
        if (values.BackgroundImage) {
          formData.append("BackgroundImage", values.BackgroundImage);
        } else {
          formData.append("BackgroundImage", "");
        }


        if (pageMode === mode.edit) {
          dispatch(updateCompanyID({
            formData,
            updateId: values.id,
            btnId
          }));
        } else {
          dispatch(saveCompany({
            formData,
            btnId
          }));
        }
      }
    } catch (e) {
      btnIsDissablefunc({ btnId, state: false });
    }
  };





  const onchangeHandler = (event) => {

    const file = event.target.files[0];
    if (!file) return;

    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      if (img.width !== 2400 || img.height !== 2400) {
        customAlert({
          Type: 4,
          Message: "Logo image dimension must be 2400 x 2400"
        });

        event.target.value = "";
        setLogoPreview(null);
        return;
      }

      //  valid image
      setState((i) => {
        const a = { ...i };
        a.values.CompanyLogo = file;
        a.isError.CompanyLogo = "";
        return a;
      });

      setLogoPreview(URL.createObjectURL(file));
    };
  };





  const onBackgroundChangeHandler = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      if (img.width !== 1536 || img.height !== 1024) {
        customAlert({
          Type: 4,
          Message: "Background image dimension must be 1536 x 1024"
        });

        event.target.value = "";
        setBgPreview(null);
        return;
      }

      //  valid image
      setState((i) => {
        const a = { ...i };
        a.values.BackgroundImage = file;
        a.isError.BackgroundImage = "";
        return a;
      });

      setBgPreview(URL.createObjectURL(file));
    };
  };





  // var IsEditMode_Css = ''
  // if ((modalCss) || (pageMode === mode.dropdownAdd)) { IsEditMode_Css = "-5.5%" };

  if (!(userPageAccessState === '')) {
    return (
      <React.Fragment>
        <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>
        <div className={"page-content"} >

          <Container fluid>
            <Row>
              <Col lg={12}>
                <Card className="text-black" >
                  <CardHeader className="card-header   text-black c_card_header" >
                    <h4 className="card-title text-black">{userPageAccessState.PageDescription}</h4>
                    <p className="card-title-desc text-black" dangerouslySetInnerHTML={{ __html: userPageAccessState.PageDescriptionDetails }} />
                  </CardHeader>

                  <CardBody>
                    <form noValidate>
                      <Card >
                        <CardBody className="c_card_body">

                          <Row>
                            <FormGroup className="mb-2 col col-sm-4 ">
                              <Label htmlFor="validationCustom01">{fieldLabel.Name} </Label>
                              <Input
                                name="Name"
                                id="txtName"
                                value={values.Name}
                                type="text"
                                className={isError.Name.length > 0 ? "is-invalid form-control" : "form-control"}
                                placeholder="Please Enter Name"
                                autoComplete='off'
                                autoFocus={true}
                                onChange={(event) => {
                                  onChangeText({ event, state, setState })
                                  dispatch(Breadcrumb_inputName(event.target.value))
                                }}
                              />
                              {isError.Name.length > 0 && (
                                <span className="invalid-feedback">{isError.Name}</span>
                              )}
                            </FormGroup>

                            <Col md="1">  </Col>
                            <FormGroup className="mb-2 col col-sm-4 ">
                              <Label htmlFor="validationCustom01">{fieldLabel.Address} </Label>
                              <Input
                                name="Address"
                                value={values.Address}
                                type="text"
                                className={isError.Address.length > 0 ? "is-invalid form-control" : "form-control"}
                                placeholder="Please Enter Address"
                                autoComplete='off'
                                onChange={(event) => onChangeText({ event, state, setState })}
                              />
                              {isError.Address.length > 0 && (
                                <span className="invalid-feedback">{isError.Address}</span>
                              )}
                            </FormGroup>
                          </Row>

                          <Row className="mb-1">
                            <FormGroup className=" col col-sm-4 ">
                              <Label htmlFor="validationCustom01">{fieldLabel.PhoneNo} </Label>
                              <Input
                                name="PhoneNo"
                                value={values.PhoneNo}
                                type="text"
                                className={isError.PhoneNo.length > 0 ? "is-invalid form-control" : "form-control"}
                                placeholder="Please Enter PhoneNo"
                                autoComplete='off'
                                onChange={(event) => {
                                  onChangeText({ event, state, setState })
                                }}
                              />
                              {isError.PhoneNo.length > 0 && (
                                <span className="invalid-feedback">{isError.PhoneNo}</span>
                              )}
                            </FormGroup>

                            <Col md="1">  </Col>
                            <FormGroup className=" col col-sm-4 ">
                              <Label htmlFor="validationCustom01">{fieldLabel.EmailID} </Label>
                              <Input
                                name="EmailID"
                                value={values.EmailID}
                                type="text"
                                className={isError.EmailID.length > 0 ? "is-invalid form-control" : "form-control"}
                                placeholder="Please Enter EmailID"
                                autoComplete='off'
                                onChange={(event) => {
                                  onChangeText({ event, state, setState })
                                }}
                              />
                              {isError.EmailID.length > 0 && (
                                <span className="invalid-feedback">{isError.EmailID}</span>
                              )}
                            </FormGroup>
                          </Row>

                        </CardBody>
                      </Card>

                      <Card className="mt-n2">
                        <CardBody className="c_card_body">

                          <Row>
                            <FormGroup className="mb-1 col col-sm-4 ">
                              <Label htmlFor="validationCustom01">{fieldLabel.GSTIN} </Label>
                              <Input
                                name="GSTIN"
                                value={values.GSTIN}
                                type="text"
                                className={isError.GSTIN.length > 0 ? "is-invalid form-control" : "form-control"}
                                placeholder="Please Enter GSTIN"
                                autoComplete='off'
                                onChange={(event) => {
                                  onChangeText({ event, state, setState })
                                }}
                              />
                              {isError.GSTIN.length > 0 && (
                                <span className="invalid-feedback">{isError.GSTIN}</span>
                              )}
                            </FormGroup>

                            <Col md="1">  </Col>
                            <FormGroup className="mb-2 col col-sm-4 ">
                              <Label htmlFor="validationCustom01">{fieldLabel.CompanyAbbreviation} </Label>
                              <Input
                                name="CompanyAbbreviation"
                                value={values.CompanyAbbreviation}
                                type="text"
                                className={isError.CompanyAbbreviation.length > 0 ? "is-invalid form-control" : "form-control"}
                                placeholder="Please Enter CompanyAbbreviation"
                                autoComplete='off'
                                onChange={(event) => {
                                  const value = event.target.value;
                                
                                  // existing logic
                                  onChangeText({ event, state, setState });
                                
                                  //  validation
                                  setState((prev) => {
                                    const err = { ...prev.isError };
                                
                                    if (value.includes(" ")) {
                                      err.CompanyAbbreviation = "Spaces are not allowed";
                                    } else if (value && !/^[A-Z]+$/.test(value)) {
                                      err.CompanyAbbreviation = "Only capital letters (A-Z) allowed";
                                    } else {
                                      err.CompanyAbbreviation = "";
                                    }
                                
                                    return { ...prev, isError: err };
                                  });
                                }}
                              />
                              {isError.CompanyAbbreviation.length > 0 && (
                                <span className="invalid-feedback">{isError.CompanyAbbreviation}</span>
                              )}
                            </FormGroup>
                          </Row>

                          <Row className=" mb-3">
                            <Col md="4">
                              <FormGroup className="mb-2 ">
                                <Label htmlFor="validationCustom01"> {fieldLabel.CompanyGroupName} </Label>
                                <Select
                                  name="CompanyGroupName"
                                  value={values.CompanyGroupName}
                                  className="react-dropdown"
                                  classNamePrefix="dropdown"
                                  options={CompanyGroupValues}
                                  onChange={(hasSelect, evn) => onChangeSelect({ hasSelect, evn, state, setState })}
                                />
                                {isError.CompanyGroupName.length > 0 && (
                                  <span className="text-danger f-8"><small>{isError.CompanyGroupName}</small></span>
                                )}
                              </FormGroup>
                            </Col>

                            <Col md="1">  </Col>
                            <FormGroup className="mb-2 col col-sm-3 mt-4">
                              <Row className="justify-content-md-left">
                                <Label className="col-sm-4 col-form-label" >{fieldLabel.IsSCM}</Label>
                                <Col md={1} style={{ marginTop: '9px', }} >

                                  <div className="form-check form-switch form-switch-md mb-3" >
                                    <Input type="checkbox" className="form-check-input"
                                      checked={values.IsSCM}
                                      name="IsSCM"
                                      onChange={(e) => {
                                        setState((i) => {
                                          const a = { ...i }
                                          a.values.IsSCM = e.target.checked;
                                          return a
                                        })
                                      }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </FormGroup>
                          </Row>

                          <Row >
                            <Col md="5">

                              <FormGroup className="mb-2 col col-sm-10">
                                <Label>Company Logo</Label>

                                <Input
                                  type="file"
                                  className={isError.CompanyLogo ? "is-invalid form-control" : "form-control"}
                                  accept=".jpg, .jpeg, .png"
                                  onChange={onchangeHandler}
                                  style={{ width: '450px' }}
                                />

                                {isError.CompanyLogo && (
                                  <span className="invalid-feedback">{isError.CompanyLogo}</span>
                                )}
                                <p style={{ color: "#ff8080", fontSize: "12px", fontStyle: "italic" }}>
                                  ( note: Logo image dimension must be 2400 x 2400 )
                                </p>



                                {logoPreview && (
                                  <div className="mt-2">
                                    <img
                                      src={logoPreview}
                                      alt="Company Logo "
                                      className="img-thumbnail"
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        objectFit: "cover",
                                        padding: "3px",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <FormGroup className="mb-2 col col-sm-8">
                                <Label>Background Image</Label>

                                <Input
                                  type="file"
                                  className={isError.BackgroundImage ? "is-invalid form-control" : "form-control"}
                                  accept=".jpg, .jpeg, .png"
                                  onChange={onBackgroundChangeHandler}
                                />

                                {isError.BackgroundImage && (
                                  <span className="invalid-feedback">{isError.BackgroundImage}</span>
                                )}
                                <p style={{ color: "#ff8080", fontSize: "12px", fontStyle: "italic" }}>
                                  ( note: Background image dimension must be 1536 x 1024 )
                                </p>

                                {bgPreview && (
                                  <div className="mt-2">
                                    <img
                                      src={bgPreview}
                                      alt="Background Preview"
                                      className="img-thumbnail"
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        objectFit: "cover",
                                        padding: "3px",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  </div>
                                )}
                              </FormGroup>



                            </Col  >

                          </Row>


                          <FormGroup className="mt-2">
                            <Row >
                              <Col sm={2}>
                                <SaveButton
                                  loading={saveBtnloading}
                                  onClick={SaveHandler}
                                  pageMode={pageMode}
                                  userAcc={userPageAccessState}
                                  editCreatedBy={editCreatedBy}
                                  module={"Company"}
                                />
                              </Col>
                            </Row>
                          </FormGroup >
                        </CardBody>
                      </Card>
                    </form>
                  </CardBody>
                </Card>
              </Col >
            </Row >
          </Container >
        </div >
      </React.Fragment >
    );
  }
  else {
    return (
      <React.Fragment></React.Fragment>
    )
  }
};
export default CompanyModule;


